import React from "react";
import { interpolateColor } from "../../shared/hooks/utils";

/**
 * Thin wrapper around `<NeuLabel>` 
 * @NeutronUpdate No updates should be needed for this but the `slot` will have no effect in Neutron 3
 */

export function Label(props: { className?: string, color?: string, children: React.ReactNode, slot?: string, onClick?: () => void, style?: React.CSSProperties }) {
    return (
        <div className={`neu-label${props.className ? ' ' + props.className : ''}${props.color ? interpolateColor(props.color) : ''}`} onClick={() => props.onClick?.()} style={props.style}>
            {props.children}
        </div>
    )
}